import { twMerge } from 'tailwind-merge';
import { cx } from 'class-variance-authority';

export function cn(...inputs) {
  return twMerge(cx(inputs));
}
